import EmailProvider from "./EmailProvider";

export { EmailProvider };


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailProvider/components/index.js